export enum ReportDataSource {
  SALESFORCE = 'Salesforce',
  SNOWFLAKE = 'Snowflake',
  CRA = 'CRA'
}
